import { forwardRef, type Ref, type SVGProps } from "react";
const IconAppDownloadOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 27.2a.934.934 0 1 0 0-1.867.934.934 0 0 0 0 1.867m-1.209-6.35a1.6 1.6 0 0 0 2.316 0l2.823-3.033a1.066 1.066 0 1 0-1.558-1.45l-1.356 1.45v-6.044a1.067 1.067 0 0 0-2.134 0v6.044l-1.355-1.45a1.068 1.068 0 0 0-1.558 1.45zM13.198 5.733a.934.934 0 1 1-1.867 0 .934.934 0 0 1 1.867 0m3.736.934h-1.868a.934.934 0 1 1 0-1.867h1.868a.934.934 0 1 1 0 1.867" />
    <path
      fillRule="evenodd"
      d="M9.462 2h13.076a1.873 1.873 0 0 1 1.868 1.867v24.266A1.873 1.873 0 0 1 22.538 30H9.462a1.873 1.873 0 0 1-1.868-1.867V3.867A1.873 1.873 0 0 1 9.462 2m0 26.133h13.076V24.4H9.462zm13.076-5.6H9.462V9.467h13.076zM9.462 7.6h13.076V3.867H9.462z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAppDownloadOutlineSVG);
ForwardRef.displayName = "IconAppDownloadOutline";
export { ForwardRef as IconAppDownloadOutline };
